import {
	eventIdUrlParam,
	eventPageUrl,
	eventSessionDayUrlParam,
	eventSessionIdUrlParam,
	eventSessionPageUrl,
	tabMenuUrlParam,
	userIdUrlParam,
	userSocialProfileOverviewPageUrl
} from '../../../../core/constants';
import { EventDetailItems, EventSessionItems } from '../../../../core/enums';
import { ClientEventSession } from '../../../../models/ClientEvent';

export const homeTab = 'home-tab';
export const agendaTab = 'agenda-tab';
export const networkTab = 'network-tab';
export const socialTab = 'social-tab';
export const agendaArrows = 'agenda-arrows';
export const agendaCard = 'agenda-card';
export const detailsTab = 'details-tab';
export const notesTab = 'notes-tab';
export const qaTab = 'qa-tab';
export const networkCard = 'network-card';
export const profileIcon = 'profile-icon';
export const networkProfileIcon = 'network-profile-icon';
export const editProfileButton = 'edit-profile-button';
export const editProfileImage = 'edit-profile-image';
export const personalInfoForm = 'personal-info-form';
export const mcdonaldsStorySection = 'mcdonalds-story-section';
export const startPostButton = 'start-post-button';
export const postActions = 'post-actions';
export const networkTabAgain = 'network-tab-again';

export const editButton = 'edit-button';

export const buildUpdatedEventTourSteps = (eventSessions: ClientEventSession[], selectedNetworkUserId: string) => {
	if (!eventSessions || eventSessions.length === 0) return [];

	const selectedSessionIndex = 7; // Hardcoded to save dev time.
	const selectedSessionDay = 2; // Hardcoded to save dev time.
	const selectedSession =
		eventSessions.find((s) => s.title === 'Registration & Day 2 Welcome Address') ??
		eventSessions[selectedSessionIndex];
	const tourSessionPageUrl = `${eventSessionPageUrl}?${eventIdUrlParam}=${selectedSession.eventId}
				&${eventSessionIdUrlParam}=${selectedSession.eventSessionId}
				&${eventSessionDayUrlParam}=${selectedSessionDay}`;

	const updatedSteps = eventTourSteps.map((step) => {
		if (step.route === 'sessionPageUrlPlaceholder') {
			return {
				...step,
				route: `${tourSessionPageUrl}&${tabMenuUrlParam}=${encodeURIComponent(step.tab)}`
			};
		}
		if (step.route === 'eventUserProfileOverviewPageUrlPlaceholder') {
			return {
				...step,
				route: `${userSocialProfileOverviewPageUrl}?${userIdUrlParam}=${selectedNetworkUserId}`
			};
		}
		return step;
	});

	return updatedSteps;
};

const eventTourSteps = [
	{
		name: EventDetailItems.Home,
		target: `[data-joyride="${homeTab}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Home}`,
		tab: EventDetailItems.Home,
		title: 'Home tab',
		content: 'On the home tab you can find contact details for The Breakers and Kelly+Partners event team.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: EventDetailItems.Agenda,
		target: `[data-joyride="${agendaTab}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Home}`,
		tab: EventDetailItems.Agenda,
		title: 'Agenda tab',
		content: 'View session times, speaker bios, takes notes and access the session Q&A.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: EventDetailItems.Network,
		target: `[data-joyride="${networkTab}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Home}`,
		tab: EventDetailItems.Network,
		title: 'Network tab',
		content: 'View unique profiles for each guest, chat, download their contact details and more.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: EventDetailItems.Social,
		target: `[data-joyride="${socialTab}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Home}`,
		tab: EventDetailItems.Social,
		title: 'Social tab',
		content: 'Share your experience from the event on the social feed, like and comment.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: `${agendaArrows}`,
		target: `[data-joyride="${agendaArrows}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Agenda}`,
		tab: EventDetailItems.Agenda,
		title: 'Navigate the agenda',
		content: 'Tap the arrows to navigate the agenda over the three day event.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: `${agendaCard}`,
		target: `[data-joyride="${agendaCard}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Agenda}`,
		tab: EventDetailItems.Agenda,
		title: 'Agenda item',
		content: 'Tap on the agenda card to view more details, write and store notes and ask questions.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: `${detailsTab}`,
		target: `[data-joyride="${detailsTab}"]`,
		route: 'sessionPageUrlPlaceholder',
		tab: EventSessionItems.Details,
		title: 'Session details',
		content: 'View an overview of the session, speaker details, directions to the meeting space and more.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: `${notesTab}`,
		target: `[data-joyride="${notesTab}"]`,
		route: 'sessionPageUrlPlaceholder',
		tab: EventSessionItems.Notes,
		title: 'Write session notes',
		content: 'In the notes section, you can type learnings and insights and come back later to view.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: `${qaTab}`,
		target: `[data-joyride="${qaTab}"]`,
		route: 'sessionPageUrlPlaceholder',
		tab: EventSessionItems.QA,
		title: 'Ask a question',
		content: 'Tap the button below to ask a question in the relevant session.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: networkTab,
		target: `[data-joyride="${networkTab}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Network}`,
		tab: EventDetailItems.Network,
		title: 'Network with guests',
		content: 'Connect with other guests, tap on their profile to learn more, chat, download their contact details.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: networkCard,
		target: `[data-joyride="${networkCard}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Network}`,
		tab: EventDetailItems.Network,
		title: 'View a profile',
		content: "Tap on a users' profile to view their profile, chat, download their contact card, email, call.",
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: `${networkProfileIcon}`,
		target: `[data-joyride="${networkProfileIcon}"]`,
		route: 'eventUserProfileOverviewPageUrlPlaceholder',
		title: 'Engage',
		content: 'Call, chat, email or save the guests contact card to your phone.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: `${profileIcon}`,
		target: `[data-joyride="${profileIcon}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Network}`,
		tab: EventDetailItems.Network,
		title: 'Event profile',
		content: 'Tab the profile icon to update your personal event profile and share your story with others.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: `${editButton}`,
		target: `[data-joyride="${editProfileButton}"]`,
		route: `${userSocialProfileOverviewPageUrl}`,
		title: 'Edit profile',
		content: "Tap edit to update your event profile to tell other guests about your McDonald's story.",
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: `${editProfileImage}`,
		target: `[data-joyride="${editProfileImage}"]`,
		route: `${userSocialProfileOverviewPageUrl}`,
		title: 'Add a profile and background image',
		content: 'Tap on the pencil to upload a profile image and unique background image for your profile.',
		placement: 'bottom' as const,
		disableBeacon: true
	},
	{
		name: `${personalInfoForm}`,
		target: `[data-joyride="${personalInfoForm}"]`,
		route: `${userSocialProfileOverviewPageUrl}`,
		title: 'Complete your personal details',
		content: 'Enter your job title and company, the rest of the details should be pre-populated.',
		placement: 'bottom' as const,
		disableBeacon: true,
		disableScrolling: false
	},
	{
		name: `${mcdonaldsStorySection}`,
		target: `[data-joyride="${mcdonaldsStorySection}"]`,
		route: `${userSocialProfileOverviewPageUrl}`,
		title: "Share your McDaondl's story",
		content: "Share your Mcdonald's story and upload photos of your resturants to share with other guests.",
		placement: 'bottom' as const,
		disableBeacon: true,
		disableScrolling: false
	},
	{
		name: `${startPostButton}`,
		target: `[data-joyride="${startPostButton}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Social}`,
		tab: EventDetailItems.Social,
		title: 'Create a social post',
		content: 'share an image with all the other guests at the event. Share your experience!',
		placement: 'bottom' as const,
		disableScrolling: false,
		disableBeacon: true
	},
	{
		name: `${postActions}`,
		target: `[data-joyride="${postActions}"]`,
		route: `${eventPageUrl}?${tabMenuUrlParam}=${EventDetailItems.Social}`,
		tab: EventDetailItems.Social,
		title: 'Engage with posts',
		content: "Like or write a comment on other people's posts and share your experience.",
		placement: 'bottom' as const,
		disableBeacon: true,
		disableScrolling: false
	}
];

export default eventTourSteps;
